<button
        matMiniFab
        [hidden]="displayPanel"
        [disabled]="!enabled"
        [class.selected]="active"
        (click)="toggleInfraredStatus()"
        id="infrared-over-button">
    CIR
</button>
